import { Header, HeaderContent, CustomerInfo, Footer, Socials } from "./index";
import { View, Text, Page, Document } from "@react-pdf/renderer";
import styles from "./style";
import { calculateProductBill } from "../utils";

const MainProductDescription = ({ bill }) => {
  return (
    <>
      <View style={styles.mainRow}>
        <Text style={{ ...styles.desc, width: "40%" }}>
          Items & Description
        </Text>
        <Text style={{ ...styles.desc, width: "15%" }}>HSN/SAC</Text>
        <Text style={{ ...styles.qty, width: "10%" }}>Qty</Text>
        <Text style={{ ...styles.unit, width: "10%" }}>Price</Text>
        <Text style={{ ...styles.unit, width: "10%", textAlign: "center" }}>
          GST
        </Text>
        <Text
          style={{ ...styles.amount, width: "15%", ...styles.amountHeader }}
        >
          Amount
        </Text>
      </View>

      <MainProductDescriptionContent bill={bill} />
    </>
  );
};

const MainProductDescriptionContent = ({ bill }) => {
  return (
    <View style={styles.mainDataRow}>
      <View style={{ ...styles.desc, ...styles.borderRightTop, width: "40%" }}>
        <Text>{bill.productName}</Text>
      </View>

      <View style={{ ...styles.qty, ...styles.borderRightTop, width: "15%" }}>
        <Text>{bill?.hsnCode || "N/A"}</Text>
      </View>

      <View style={{ ...styles.qty, ...styles.borderRightTop, width: "10%" }}>
        <Text>{bill.quantity}</Text>
      </View>

      <View style={{ ...styles.unit, ...styles.borderRightTop, width: "10%" }}>
        <Text>{bill.sellingPriceWOT}</Text>
      </View>

      <View style={{ ...styles.unit, ...styles.borderRightTop, width: "10%" }}>
        <Text>{bill.gst}%</Text>
      </View>

      <View
        style={{ ...styles.amount, ...styles.borderRightTop, width: "15%" }}
      >
        <Text>{bill.totalAmount}</Text>
      </View>
    </View>
  );
};

const AmountSection = ({ bill }) => {
  return (
    <View style={styles.invoiceAmount}>
      <View style={styles.blank} />
      <View style={styles.summaryTitle}>
        <Text>Subtotal</Text>
        <Text>Total Tax Amount</Text>
        <Text style={styles.total}>Total</Text>
        <Text>Discount</Text>
        <Text>Amount Paid</Text>
        <Text style={styles.balance}>Balance</Text>
      </View>

      <View style={styles.summaryValue}>
        <Text>{bill.totalAmountBeforeTax}</Text>
        <Text>{bill.gstAmount}</Text>
        <Text>{bill.totalAmount}</Text>
        <Text>{bill.discount}</Text>
        <Text>{bill.amountPaid}</Text>
        <Text>{bill.balance}</Text>
        <Text style={styles.totalVal}>₹ {bill.balance}</Text>
      </View>
    </View>
  );
};

const MyProductINVPDF = ({ user, bill, note }) => {
  console.log({ bill });
  console.log({ user });
  const calculatedBill = calculateProductBill(bill);

  return (
    <Document>
      <Page style={styles.page} size="A3">
        <Header user={user} />
        <HeaderContent user={user} bill={calculatedBill} />
        <CustomerInfo bill={calculatedBill} />
        <MainProductDescription bill={calculatedBill} />
        <AmountSection bill={calculatedBill} />
        <Footer user={user} />
        <Socials
          user={user}
          bill={calculatedBill}
        //   note={user.termsAndConditions}
        //   termsAndCondition={user.termsAndConditions}
        />
      </Page>
    </Document>
  );
};

export default MyProductINVPDF;
